export const fieldMappings = {
    'costs': 'create',
    'costs.currency': 'connect',
    'costs.costSupplier': 'connect',
    areaBookings: 'create',
    'regionalAmAllocation':'connect',
    'areaBookings.areaBookingItems.campaignComponent.region': 'connect',
    'areaBookings.areaBookingItems.campaignComponent.currency': 'connect',
    'areaBookings.posterSize': 'connect',
    'areaBookings.regionType': 'connect',
    'areaBookings.currency': 'connect', 
    'areaBookings.areaBookingItems': 'create',
    'areaBookings.areaBookingItems.distributor': 'connect',
    'clientCompany': 'connect',
    'clientCompanyContact': 'connect',
    'clientSubType': 'connect',
    'currency': 'connect',
    'currencies': 'connect',
    'mediaProductions': 'create',
    'mediaProductions.mediaType': 'connect',
    'mediaProductions.size': 'connect',
    'mediaProductions.campaignComponent.currency': 'connect',
    'creativeStudio': 'create',
    'creativeStudio.creativeStudioType': 'connect',
    'creativeStudio.campaignComponent.region': 'connect',
    'creativeStudio.campaignComponent.regionType': 'connect',
    'creativeStudio.creativeStudioTypeDetail': 'connect',
    'creativeStudio.campaignComponent.currency': 'connect',
    'experientials.experientialType': 'connect',
    'experientials.campaignComponent.region': 'connect',
    'experientials.campaignComponent.regionType': 'connect',
    'experientials.campaignComponent.currency': 'connect',
    'ambients.ambientType': 'connect',
    'ambients.campaignComponent.region': 'connect',
    'ambients.campaignComponent.currency': 'connect',
    'sundries.sundryType': 'connect',
    'sundries.campaignComponent.regionType': 'connect',
    'sundries.campaignComponent.region': 'connect',
    'sundries.campaignComponent.currency': 'connect',
    'ourContact': 'connect',
    'panelBookings': 'create', // trash
    'salesTeam': 'connect',
    'previewTags':'connect',
    'paymentTerms':'connect',
    'artworkFiles.distributor': 'connect'
};